import { useMemo } from "react";
import type {
    DataGridLoadMoreOptions,
    DataGridLoadMoreState,
} from "../../types";

/** `loadMore`'s flags as one object that changes only with their values. */
export const useLoadMoreState = (
    loadMore: DataGridLoadMoreOptions | undefined,
): DataGridLoadMoreState | undefined => {
    const isEnabled = loadMore !== undefined;
    const hasMore = loadMore?.hasMore ?? false;
    const isLoading = loadMore?.isLoading ?? false;
    const isError = loadMore?.isError ?? false;
    const resetKey = loadMore?.resetKey;
    const rowCount = loadMore?.rowCount;
    return useMemo(
        () =>
            isEnabled
                ? { hasMore, isLoading, isError, resetKey, rowCount }
                : undefined,
        [isEnabled, hasMore, isLoading, isError, resetKey, rowCount],
    );
};
